// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
.ResetNewPassword_scroll__LE0jH::-webkit-scrollbar {
  height: 8px;
}
.ResetNewPassword_scroll__LE0jH::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.ResetNewPassword_scroll__LE0jH::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

.ResetNewPassword_ResetNewPassword__iiFGe {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  overflow: hidden;
}
.ResetNewPassword_ResetNewPassword__iiFGe > svg {
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-36%, -28%);
  width: 65%;
  z-index: -1;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_loginBox__JrB6Y {
  max-width: 762px;
  width: 762px;
  background-color: var(--bgColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 {
  padding: 100px 132px;
  color: var(--mainColor);
  position: relative;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 {
  font-size: 14px !important;
  display: inline-block;
  margin-bottom: 30px;
}
body[dir=ltr] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 + span {
  color: var(--errorColor);
  font-size: 12px !important;
  position: absolute;
  opacity: 0;
}
body[dir=ltr] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 + span {
  left: 50%;
}
body[dir=rtl] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 h4 + span {
  right: 50%;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 label {
  font-size: 12px !important;
  margin-bottom: 9px;
  display: block;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 input {
  width: 100%;
  height: 40px;
  -webkit-padding-start: 10px;
          padding-inline-start: 10px;
  border: 0;
  border: 1px solid var(--borderColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 input:focus-visible {
  outline: none !important;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 input:focus:invalid {
  border-color: var(--errorColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 input:focus {
  border-color: var(--secondaryColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 .ResetNewPassword_checkParent__5ig2O {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 .ResetNewPassword_checkParent__5ig2O a {
  font-size: 12px !important;
  text-decoration: underline !important;
}
body[dir=ltr] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 .ResetNewPassword_checkParent__5ig2O a {
  float: right;
}
body[dir=rtl] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_Form__GE045 .ResetNewPassword_checkParent__5ig2O a {
  float: left;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_button_Box__kg6s8 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_button_Box__kg6s8 button {
  width: 130px;
  height: 40px;
  border: none;
  background-color: var(--secondaryColor);
  color: #fff;
  margin-top: 10px;
  cursor: pointer;
  font-family: inherit;
  transition: 0.3s;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_button_Box__kg6s8 button:hover {
  background-color: var(--bgColor);
  border: 1px solid var(--secondaryColor);
  color: var(--secondaryColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_button_Box__kg6s8 a {
  color: var(--secondaryColor);
  font-size: 12px !important;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_fieldSpan__0S42- {
  color: var(--errorColor);
  font-size: 12px !important;
  position: absolute;
  opacity: 0;
}
body[dir=ltr] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_fieldSpan__0S42- {
  right: 2%;
  transform: translate(-100%, 0);
}
body[dir=rtl] .ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_fieldSpan__0S42- {
  left: 7%;
  transform: translate(100%, 0);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_error__eNERt {
  color: var(--errorColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_error__eNERt input {
  border-color: var(--errorColor);
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_error__eNERt .ResetNewPassword_fieldSpan__0S42- {
  opacity: 1;
}
.ResetNewPassword_ResetNewPassword__iiFGe .ResetNewPassword_wrong__kAMg2 h4 + span {
  opacity: 1;
}

.grecaptcha-badge {
  z-index: 9999 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/auth/pages/ResetNewPassword/ResetNewPassword.module.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;AD2HE;EACE,WAAA;ACzHJ;AD4HE;EACE,kCAAA;AC1HJ;AD6HE;EACE,kCAAA;AC3HJ;;AAnDA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;AAuDJ;AArDE;EACE,gBAAA;EACA,YAAA;EACA,gCAAA;AAuDJ;AArDE;EACE,oBAAA;EACA,uBAAA;EACA,kBAAA;AAuDJ;AArDI;EDmFA,0BAAA;ECjFE,qBAAA;EACA,mBAAA;AAuDN;AD0BI;EACE,2DAAA;ACxBN;AD0BI;EACE,2DAAA;ACxBN;AA3DI;EACE,wBAAA;ED2EF,0BAAA;ECnEE,kBAAA;EACA,UAAA;AAuDN;AA9DM;EACE,SAAA;AAgER;AA9DM;EACE,UAAA;AAgER;AA1DI;ED+DA,0BAAA;EC7DE,kBAAA;EACA,cAAA;AA4DN;AAzDI;EACE,WAAA;EACA,YAAA;EACA,2BAAA;UAAA,0BAAA;EACA,SAAA;EACA,oCAAA;AA2DN;AAzDM;EACE,wBAAA;AA2DR;AAzDM;EACE,+BAAA;AA2DR;AAzDM;EACE,mCAAA;AA2DR;AAvDI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAyDN;AAxDM;EDmCF,0BAAA;EC3BI,qCAAA;AAoDR;AA3DQ;EACE,YAAA;AA6DV;AA3DQ;EACE,WAAA;AA6DV;AAtDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAwDJ;AArDI;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,uCAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;AAuDN;AArDM;EACE,gCAAA;EACA,uCAAA;EACA,4BAAA;AAuDR;AApDI;EACE,4BAAA;EDDF,0BAAA;ACwDJ;AAnDE;EACE,wBAAA;EDNA,0BAAA;ECQA,kBAAA;EASA,UAAA;AA6CJ;AArDI;EACE,SAAA;EACA,8BAAA;AAuDN;AArDI;EACE,QAAA;EACA,6BAAA;AAuDN;AAnDE;EACE,wBAAA;AAqDJ;AApDI;EACE,+BAAA;AAsDN;AApDI;EACE,UAAA;AAsDN;AAlDI;EACE,UAAA;AAoDN;;AA/CE;EACE,wBAAA;AAkDJ","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import 'app/assets/scss/vars.scss';\n\n.ResetNewPassword {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  overflow: hidden;\n  > svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    transform: translate(-36%, -28%);\n    width: 65%;\n    z-index: -1;\n  }\n  .loginBox {\n    max-width: 762px;\n    width: 762px;\n    background-color: var(--bgColor);\n  }\n  .Form {\n    padding: 100px 132px;\n    color: var(--mainColor);\n    position: relative;\n\n    h4 {\n      @include fontSize(14);\n      display: inline-block;\n      margin-bottom: 30px;\n    }\n    h4 + span {\n      color: var(--errorColor);\n      @include fontSize(12);\n      #{$ltr} & {\n        left: 50%;\n      }\n      #{$rtl} & {\n        right: 50%;\n      }\n      position: absolute;\n      opacity: 0;\n    }\n\n    label {\n      @include fontSize(12);\n      margin-bottom: 9px;\n      display: block;\n    }\n\n    input {\n      width: 100%;\n      height: 40px;\n      padding-inline-start: 10px;\n      border: 0;\n      border: 1px solid var(--borderColor);\n\n      &:focus-visible {\n        outline: none !important;\n      }\n      &:focus:invalid {\n        border-color: var(--errorColor);\n      }\n      &:focus {\n        border-color: var(--secondaryColor);\n      }\n    }\n\n    .checkParent {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      a {\n        #{$ltr} & {\n          float: right;\n        }\n        #{$rtl} & {\n          float: left;\n        }\n        @include fontSize(12);\n        text-decoration: underline !important;\n      }\n    }\n  }\n  .button_Box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    // margin-top: 20px;\n\n    button {\n      width: 130px;\n      height: 40px;\n      border: none;\n      background-color: var(--secondaryColor);\n      color: #fff;\n      margin-top: 10px;\n      cursor: pointer;\n      font-family: inherit;\n      transition: 0.3s;\n\n      &:hover {\n        background-color: var(--bgColor);\n        border: 1px solid var(--secondaryColor);\n        color: var(--secondaryColor);\n      }\n    }\n    a {\n      color: var(--secondaryColor);\n      @include fontSize(12);\n    }\n  }\n  .fieldSpan {\n    color: var(--errorColor);\n    @include fontSize(12);\n    position: absolute;\n    #{$ltr} & {\n      right: 2%;\n      transform: translate(-100%, 0);\n    }\n    #{$rtl} & {\n      left: 7%;\n      transform: translate(100%, 0);\n    }\n    opacity: 0;\n  }\n  .error {\n    color: var(--errorColor);\n    input {\n      border-color: var(--errorColor);\n    }\n    .fieldSpan {\n      opacity: 1;\n    }\n  }\n  .wrong {\n    h4 + span {\n      opacity: 1;\n    }\n  }\n}\n:global {\n  .grecaptcha-badge {\n    z-index: 9999 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `ResetNewPassword_scroll__LE0jH`,
	"ResetNewPassword": `ResetNewPassword_ResetNewPassword__iiFGe`,
	"loginBox": `ResetNewPassword_loginBox__JrB6Y`,
	"Form": `ResetNewPassword_Form__GE045`,
	"checkParent": `ResetNewPassword_checkParent__5ig2O`,
	"button_Box": `ResetNewPassword_button_Box__kg6s8`,
	"fieldSpan": `ResetNewPassword_fieldSpan__0S42-`,
	"error": `ResetNewPassword_error__eNERt`,
	"wrong": `ResetNewPassword_wrong__kAMg2`
};
export default ___CSS_LOADER_EXPORT___;
